
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[[...wordpressCorporateEN]]",
      function () {
        return require("private-next-pages/[[...wordpressCorporateEN]].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[[...wordpressCorporateEN]]"])
      });
    }
  